@if (patient$ | async; as patient) {
  <div class="flex flex-col overflow-hidden py-2">
    <div class="flex items-center gap-2">
      <span class="min-w-0 truncate font-medium">{{ patient.name }}</span>
      @if (patient.status !== patientStatus.Active) {
        <pr-patient-status-chip [status]="patient.status" />
      }
    </div>
    @if (details$ | async; as details) {
      <span class="truncate text-xs text-slate-500">{{ details }}</span>
    }
  </div>
}
